import { render, staticRenderFns } from "./NeoparentNewProfile.vue?vue&type=template&id=3003c9d6&scoped=true"
import script from "./NeoparentNewProfile.vue?vue&type=script&lang=js"
export * from "./NeoparentNewProfile.vue?vue&type=script&lang=js"
import style0 from "./NeoparentNewProfile.vue?vue&type=style&index=0&id=3003c9d6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3003c9d6",
  null
  
)

export default component.exports